import http from 'utils/http';
import { MetaApiResponse } from 'utils/types/CommonApiResponse';
import { getAuditTrailsUrl } from './apiUrls';
import { AuditTrail } from './types';

export function getAuditTrails(params: any): Promise<{ data: AuditTrail[]; meta: MetaApiResponse }> {
  return http.get(getAuditTrailsUrl(), params);
}
